import { Cancel, Check, Delete, Edit, RestoreFromTrash } from '@mui/icons-material';
import { FormControl, IconButton, TableCell, TableRow } from '@mui/material';
import { green, orange, red } from '@mui/material/colors';

const rowStyles = {
  tableRow: {
    height: 53,
  },
  iconButton: {
    marginRight: 4,
  },
  bgGreen: {
    backgroundColor: green[600],
  },
  bgRed: {
    backgroundColor: red[600],
  },
  bgOrange: {
    backgroundColor: orange[600],
  },
  buttons: {
    whiteSpace: 'nowrap',
  },
};

export interface EditableRowProps {
  itemKey?: string | number;
  data: Array<any> | any;
  areActionsDisabled: boolean;
  isOnEditMode: boolean;
  isEditable: boolean;
  isSaveable: boolean;
  onEditRow?: () => void;
  onCancelEdit?: () => void;
  onRemoveRow: () => void;
  onSaveRow: () => void;
  added?: boolean;
  deleted?: boolean;
  edited?: boolean;
}

export const EditableRow = ({
  data,
  itemKey,
  areActionsDisabled,
  isOnEditMode,
  isEditable,
  isSaveable,
  onEditRow,
  onRemoveRow,
  onSaveRow,
  onCancelEdit,
  added,
  deleted,
  edited,
}: EditableRowProps) => (
  <TableRow
    sx={{
      ...rowStyles.tableRow,
      ...(added ? rowStyles.bgGreen : {}),
      ...(edited ? rowStyles.bgOrange : {}),
      ...(deleted ? rowStyles.bgRed : {}),
    }}
  >
    {data.map((item, idx) => (
      <TableCell
        key={(itemKey || '') + ((typeof item !== 'object' && item !== '' && item) || idx)}
        align="left"
      >
        <FormControl fullWidth={true}>{item}</FormControl>
      </TableCell>
    ))}
    <TableCell padding="none" align="center" sx={rowStyles.buttons}>
      {!areActionsDisabled &&
        (isOnEditMode ? (
          <>
            <IconButton
              data-testid="add-relation-check"
              sx={rowStyles.iconButton}
              disabled={!isSaveable}
              size="small"
              onClick={onSaveRow}
            >
              <Check />
            </IconButton>
            <IconButton
              data-testid="add-relation-cancel"
              sx={rowStyles.iconButton}
              size="small"
              onClick={onCancelEdit}
            >
              <Cancel />
            </IconButton>
          </>
        ) : (
          <>
            {isEditable && !deleted && (
              <IconButton
                data-testid="add-relation-edit"
                sx={rowStyles.iconButton}
                size="small"
                onClick={onEditRow}
              >
                <Edit />
              </IconButton>
            )}
            <IconButton
              data-testid="add-relation-delete"
              title={deleted ? 'restore' : 'delete'}
              sx={rowStyles.iconButton}
              size="small"
              onClick={onRemoveRow}
            >
              {deleted ? <RestoreFromTrash /> : <Delete />}
            </IconButton>
          </>
        ))}
    </TableCell>
  </TableRow>
);
